export const experienceData = [
    {
        id: 1,
        company: 'hokify, Vienna',
        jobtitle: 'Senior DevOps Engineer',
        startYear: 'Jan 2026',
        endYear: 'Present',
        current: true,
        bullets: [
            'Working extensively on site reliability at hokify, with a focus on dependable production systems, observability, and incident-response workflows.',
            'Maintaining AWS infrastructure and CI/CD pipelines built on GitHub Actions.',
            'Operating a managed OpenSearch cluster for log aggregation, search, and analysis.',
            'Building out full security and observability systems across the stack — from infrastructure to application layer.',
            'Defining and rolling out best-practice security procedures and incident-response workflows.',
            'Building and maintaining Grafana dashboards for real-time system and security visibility.',
        ],
        tags: ['Site Reliability', 'AWS', 'GitHub Actions', 'OpenSearch', 'Grafana', 'Security'],
    },
    {
        id: 2,
        company: 'Eversports GmbH, Vienna',
        jobtitle: 'Senior Platform Engineer',
        startYear: 'Jul 2025',
        endYear: 'Dec 2025',
        bullets: [
            'Strengthened AWS security posture to align with NIS2 compliance requirements.',
            'Navigated a large TypeScript CDK-based monorepo, driving infrastructure improvements across multiple AWS accounts.',
            'Optimized CI/CD pipelines on CircleCI, resolving multi-pipeline deployment issues in a shared AWS environment.',
            'Built an automation system that generates infrastructure diagrams directly from CloudFormation stacks.',
            'Configured cross-account IAM roles to streamline secure deployments and access management.',
        ],
        tags: ['AWS CDK', 'CircleCI', 'CloudFormation', 'IAM', 'NIS2'],
    },
    {
        id: 3,
        company: 'Viora GmbH, Vienna',
        jobtitle: 'Senior Systems Infrastructure & Backend Architect',
        startYear: 'Oct 2022',
        endYear: 'Jun 2025',
        bullets: [
            'Migrated the back-end Kubernetes structure from GCP to AWS.',
            'Designed and architected back-end infrastructure across AWS services, including CDN-based edge architecture.',
            'Broke down a monolithic GCP Kubernetes back-end into microservices.',
            'Built multiple CI/CD pipelines and backup systems, and developed custom VM images for multiple codebases.',
            'Developed Python pipelines for AI models and real-time data streaming via WebSockets in the Flutter app.',
        ],
        tags: ['Kubernetes', 'AWS', 'GCP', 'Microservices', 'Python'],
    },
    {
        id: 4,
        company: 'Saveeye, Denmark (Remote)',
        jobtitle: 'Senior Cloud & IoT Solutions Architect',
        startYear: 'Nov 2022',
        endYear: 'Jan 2025',
        bullets: [
            'Designed and managed IoT device connectivity using MQTT, ThingsBoard, and cloud infrastructure.',
            'Led the transition from Kubernetes to AWS ECS, reducing cloud costs while maintaining high availability.',
            'Deployed and maintained AWS infrastructure including ECS, Lambda, CloudWatch, and WAF; designed custom VPCs.',
            'Built CI/CD pipelines for firmware deployment using AWS CodeBuild and S3 versioning.',
            'Diagnosed and resolved ECS RAM/storage issues and backend database issues in PostgreSQL and TimescaleDB.',
        ],
        tags: ['AWS ECS', 'MQTT', 'ThingsBoard', 'WAF', 'PostgreSQL'],
    },
    {
        id: 5,
        company: 'Sustainable Universal Golden Arc Co. (UGA), Shiraz',
        jobtitle: 'Web Developer and Backend Architect',
        startYear: 'Aug 2021',
        endYear: 'Aug 2022',
        condensed:
            'Built an e-commerce platform end-to-end — AWS backend, Jenkins CI/CD, Dockerized AWS ECS deployment, Firebase push notifications, and a PHP CMS.',
    },
    {
        id: 6,
        company: 'Amvaj Nouri Co. (Miz Pezeshk), Shiraz – Bushehr',
        jobtitle: 'Mobile App Developer & Systems Infrastructure Developer',
        startYear: 'Oct 2019',
        endYear: 'Jan 2021',
        condensed:
            'Built a cross-platform Flutter/Dart patient-tracking app with a PHP/MySQL backend, AWS CloudFormation server clusters, and a native Android (Java) companion app.',
    },
    {
        id: 7,
        company: 'Mehragan Agriculture Cooperative Company (RiraTrade), Abdan',
        jobtitle: 'Senior Software Engineer & Backend Designer',
        startYear: 'Mar 2018',
        endYear: 'Jun 2019',
        condensed:
            'Ran a Kubernetes-based backend with CI/CD pipelines, custom mailing systems, and end-to-end encrypted data streams; owned monitoring, recovery, and backup procedures.',
    },
    {
        id: 8,
        company: 'Building Design Engineering Office (IzeeTech), Shiraz',
        jobtitle: 'Web & Mobile Developer, Backend Architect',
        startYear: 'Jul 2015',
        endYear: 'Jun 2017',
        condensed:
            'Built an e-commerce and employee-management system on AWS with a Python/PostgreSQL backend and a native Java Android app.',
    },
    {
        id: 9,
        company: 'Kazemi Law Office, Tehran',
        jobtitle: 'Mobile App & Backend Developer',
        startYear: 'Apr 2014',
        endYear: 'Jun 2015',
        condensed:
            'Built an Android app and PHP backend, plus a private mail server and local VM backup infrastructure — the start of it all.',
    },
]
